export default class BPBeginnenRequest {
  id: string
  filialeId: string
  terminart: string
  direktabholung: boolean = false
  tischId: string
  identifier: string
  liefergebietId: string
  lieferungStrasse: string
  lieferungPlz: string
  lieferungOrt: string
}
